import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class StereoMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.itemMasterServices = new ItemMasterServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      tableStatus: "",
      stereoDataList: [],
      stereoDetails: {
        stereoName: "",
      },
    };
  }

  componentDidMount() {
    this.getAllStereoData();
  }

  getAllStereoData = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllStereoData().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { stereoDataList: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditStereo = () => {
    if (this.state.stereoDetails.stereoName !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.stereoDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditStereo(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.resetForm();
            this.SwalServices.Success(response.Message);
            this.setState({ isLoading: false })
          } else {
            this.SwalServices.Error(
              response.Message
            );
            this.setState({ isLoading: false })
          }
        });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.stereoDetails;
    details.stereoName = "";
    this.setState({ stereoDetails: details }, () => {
      this.setState({ _id: "", isEditing: false, tableStatus: "" }, () => {
        console.log(this.state._id);
        this.getAllStereoData();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.stereoDetails;
    details[name] = value.toUpperCase();
    this.setState({ stereoDetails: details });
  };

  getStereoById = (group) => {
    let details = this.state.stereoDetails;
    details.stereoName = group.stereoName;
    this.setState({ stereoDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteStereoById = (id) => {
    this.itemMasterServices.deleteStereoById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllStereoData();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table">
            <div className="item-grp !w-[50%] !mb-3.5">
              <label>Stereo Name</label>
              <input
                className="inputFocus"
                type="text"
                id="stereoName"
                name="stereoName"
                autoComplete="off"
                value={this.state.stereoDetails.stereoName}
                onChange={(event) => this.handleChange(event, "stereoName")}
              />
            </div>
            <div className="btn-grp">

              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditStereo()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditStereo()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()} disabled={this.state.isLoading}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '80%' }}>Stereo</td>

                    <td style={{ width: '20%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.stereoDataList &&
                    this.state.stereoDataList.length > 0 ?
                    this.state.stereoDataList.map((group, key) => (
                      <tr key={key}>
                        <td>{group.stereoName}</td>

                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getStereoById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deleteStereoById(group._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.stereoDataList &&
                      this.state.stereoDataList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.stereoDataList &&
                      this.state.stereoDataList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StereoMaster;
